module.exports = __webpack_public_path__ + "img/rubber_ducky_material.1a1fde34.png";